import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Statement from './Statement'; 

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
};

const App = ({repaymentDet,emiDet}) => {
  //console.log("app---->",repaymentDet,emiDet)
  const totalremainingAmountToBePaid = emiDet?.reduce((sum, item) => {
  return sum + (item?.remainingAmountToBePaid || 0);
  }, 0);
  const totalPrincipalOutstanding = emiDet?.reduce((sum, item) => {
    if (item?.status === 1 || item?.status === 3 || item?.status === 5) {
      const outstanding = (item?.principleAmount || 0) - (item?.paidPrinciple || 0);
      return sum + outstanding;
    }
    return sum;
  }, 0);
  const statementDetails = {
    customerInfo: {
      customerName: repaymentDet?.firstName + "" + repaymentDet?.lastName,
      loanId: repaymentDet?.legacyLoanId,
      applicationDate: formatDate(repaymentDet?.applideDate),
      disbursalDate: formatDate(repaymentDet?.disbursedDate),
      email: repaymentDet?.email ? repaymentDet?.email :"",
      closureDate: repaymentDet?.closureDate ?formatDate(repaymentDet?.closureDate):"NA",
      address: repaymentDet?.address,
    },
    loanDetails: {
      lenderName: "Monk Capital Private Limited",
      loanAmount: `Rs. ${repaymentDet?.loanAmount?.toLocaleString('en-IN')}`,
      tenure: `${repaymentDet?.tenure} months`,
      totalDue: `Rs. ${totalremainingAmountToBePaid?.toLocaleString('en-IN')}`,
      principalOutstanding: `Rs. ${totalPrincipalOutstanding?.toLocaleString('en-IN')}`,
    },
    statementData: emiDet
  };

  const date = new Date().toLocaleDateString();
  const fileName = `Statement_${statementDetails.customerInfo.customerName.replace(/\s+/g, '_')}_${date.replace(/\//g, '-')}.pdf`;

  return (
    <div>
        <PDFDownloadLink
            document={<Statement data={statementDetails} />}
            fileName={fileName}
            style={{
                       fontFamily: "Inter-Medium",
                       fontSize: "14px"
                       ,whiteSpace:'nowrap',textDecoration:'none',color:'black'
                     }}
        >
            Loan Statement
        </PDFDownloadLink>
    </div>
  );
};

export default App;